module.exports = __webpack_public_path__ + "static/media/calendar-today.0459aaeb.ts";